import { render, staticRenderFns } from "./ModifyPwdBox.vue?vue&type=template&id=7096d6f7&scoped=true"
import script from "./ModifyPwdBox.vue?vue&type=script&lang=js"
export * from "./ModifyPwdBox.vue?vue&type=script&lang=js"
import style0 from "./ModifyPwdBox.vue?vue&type=style&index=0&id=7096d6f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7096d6f7",
  null
  
)

export default component.exports